<div class="pdf-color-settings">
  @if (loading) {
    <div class="loading-container">
      <nx-spinner nxSize="medium"></nx-spinner>
    </div>
  }

  @if (!loading && settings) {
    <div nxLayout="grid">
      <div nxRow="">
        <div nxCol="12">
          <h4 class="section-title">{{'pdfColors.sections.coverPage' | caption}}</h4>
        </div>
        @for (field of getFieldsBySection('coverPage'); track field) {
          <div nxCol="12,12,6,4" class="color-field">
            <div class="color-label">{{field.label | caption}}</div>
            <div class="color-picker-wrapper">
              <div class="color-preview"
                [style.backgroundColor]="settings[field.key]"
                (click)="toggleColorPicker(field.key)">
              </div>
              <span class="color-value">{{settings[field.key]}}</span>
            </div>
            @if (activeColorPicker === field.key) {
              <div class="color-picker-container" [class.open-upward]="openUpward">
                <color-chrome [color]="settings[field.key]" (onChangeComplete)="changeColor(field.key, $event)"></color-chrome>
              </div>
            }
          </div>
        }
      </div>
      <div nxRow="">
        <div nxCol="12">
          <h4 class="section-title">{{'pdfColors.sections.toc' | caption}}</h4>
        </div>
        @for (field of getFieldsBySection('toc'); track field) {
          <div nxCol="12,12,6,4" class="color-field">
            <div class="color-label">{{field.label | caption}}</div>
            <div class="color-picker-wrapper">
              <div class="color-preview"
                [style.backgroundColor]="settings[field.key]"
                (click)="toggleColorPicker(field.key)">
              </div>
              <span class="color-value">{{settings[field.key]}}</span>
            </div>
            @if (activeColorPicker === field.key) {
              <div class="color-picker-container" [class.open-upward]="openUpward">
                <color-chrome [color]="settings[field.key]" (onChangeComplete)="changeColor(field.key, $event)"></color-chrome>
              </div>
            }
          </div>
        }
      </div>
      <div nxRow="">
        <div nxCol="12">
          <h4 class="section-title">{{'pdfColors.sections.chartSidebar' | caption}}</h4>
        </div>
        @for (field of getFieldsBySection('chartSidebar'); track field) {
          <div nxCol="12,12,6,4" class="color-field">
            <div class="color-label">{{field.label | caption}}</div>
            <div class="color-picker-wrapper">
              <div class="color-preview"
                [style.backgroundColor]="settings[field.key]"
                (click)="toggleColorPicker(field.key)">
              </div>
              <span class="color-value">{{settings[field.key]}}</span>
            </div>
            @if (activeColorPicker === field.key) {
              <div class="color-picker-container" [class.open-upward]="openUpward">
                <color-chrome [color]="settings[field.key]" (onChangeComplete)="changeColor(field.key, $event)"></color-chrome>
              </div>
            }
          </div>
        }
      </div>
      <div nxRow="">
        <div nxCol="12">
          <h4 class="section-title">{{'pdfColors.sections.chartBox' | caption}}</h4>
        </div>
        @for (field of getFieldsBySection('chartBox'); track field) {
          <div nxCol="12,12,6,4" class="color-field">
            <div class="color-label">{{field.label | caption}}</div>
            <div class="color-picker-wrapper">
              <div class="color-preview"
                [style.backgroundColor]="settings[field.key]"
                (click)="toggleColorPicker(field.key)">
              </div>
              <span class="color-value">{{settings[field.key]}}</span>
            </div>
            @if (activeColorPicker === field.key) {
              <div class="color-picker-container" [class.open-upward]="openUpward">
                <color-chrome [color]="settings[field.key]" (onChangeComplete)="changeColor(field.key, $event)"></color-chrome>
              </div>
            }
          </div>
        }
      </div>
      <div nxRow="">
        <div nxCol="12">
          <h4 class="section-title">{{'pdfColors.sections.footer' | caption}}</h4>
        </div>
        @for (field of getFieldsBySection('footer'); track field) {
          <div nxCol="12,12,6,4" class="color-field">
            <div class="color-label">{{field.label | caption}}</div>
            <div class="color-picker-wrapper">
              <div class="color-preview"
                [style.backgroundColor]="settings[field.key]"
                (click)="toggleColorPicker(field.key)">
              </div>
              <span class="color-value">{{settings[field.key]}}</span>
            </div>
            @if (activeColorPicker === field.key) {
              <div class="color-picker-container" [class.open-upward]="openUpward">
                <color-chrome [color]="settings[field.key]" (onChangeComplete)="changeColor(field.key, $event)"></color-chrome>
              </div>
            }
          </div>
        }
      </div>
      <div nxRow="">
        <div nxCol="12">
          <h4 class="section-title">{{'pdfColors.sections.general' | caption}}</h4>
        </div>
        @for (field of getFieldsBySection('general'); track field) {
          <div nxCol="12,12,6,4" class="color-field">
            <div class="color-label">{{field.label | caption}}</div>
            <div class="color-picker-wrapper">
              <div class="color-preview"
                [style.backgroundColor]="settings[field.key]"
                (click)="toggleColorPicker(field.key)">
              </div>
              <span class="color-value">{{settings[field.key]}}</span>
            </div>
            @if (activeColorPicker === field.key) {
              <div class="color-picker-container" [class.open-upward]="openUpward">
                <color-chrome [color]="settings[field.key]" (onChangeComplete)="changeColor(field.key, $event)"></color-chrome>
              </div>
            }
          </div>
        }
      </div>
      <div nxRow="">
        <div nxCol="12">
          <h4 class="section-title">{{'pdfColors.sections.chartSidebar' | caption}}</h4>
        </div>
        <div nxCol="12,12,6,4" class="color-field">
          <nx-switcher [(checked)]="settings.showSidebarBottomText">
            {{'pdfColors.chartSidebar.showBottomText' | caption}}
          </nx-switcher>
        </div>
      </div>
      <div nxRow="">
        <div nxCol="12">
          <h4 class="section-title">{{'pdfColors.sections.images' | caption}}</h4>
        </div>
        <div nxCol="12,12,6,6" class="image-field">
          <div class="image-label">{{'pdfColors.images.backgroundImage' | caption}}</div>
          <div class="image-preview-wrapper">
            @if (settings.backgroundImage) {
              <figure nxFigure="">
                <img class="image-preview"
                  [src]="settings.backgroundImage.srcWidth"
                  alt="Background Image"
                  (error)="settings.backgroundImage.srcWidth = 'assets/img/default.png'"
                  />
                </figure>
              }
              <div class="image-buttons">
                <button nxButton="secondary small" type="button" (click)="openBackgroundImageModal()">
                  {{'pdfColors.images.selectImage' | caption}}
                </button>
                @if (settings.backgroundImage) {
                  <button nxButton="secondary small" type="button" (click)="removeBackgroundImage()">
                    <nx-icon name="trash"></nx-icon>
                  </button>
                }
              </div>
            </div>
          </div>
          <div nxCol="12,12,6,6" class="image-field">
            <div class="image-label">{{'pdfColors.images.logoImage' | caption}}</div>
            <div class="image-preview-wrapper">
              @if (settings.logoImage) {
                <figure nxFigure="">
                  <img class="image-preview"
                    [src]="settings.logoImage.srcWidth"
                    alt="Logo Image"
                    (error)="settings.logoImage.srcWidth = 'assets/img/default.png'"
                    />
                  </figure>
                }
                <div class="image-buttons">
                  <button nxButton="secondary small" type="button" (click)="openLogoImageModal()">
                    {{'pdfColors.images.selectImage' | caption}}
                  </button>
                  @if (settings.logoImage) {
                    <button nxButton="secondary small" type="button" (click)="removeLogoImage()">
                      <nx-icon name="trash"></nx-icon>
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
          <div nxRow="" class="nx-margin-top-m">
            <div nxCol="12" class="button-row">
              <button nxButton="secondary small" type="button" (click)="resetToDefaults()">
                {{'pdfColors.resetToDefaults' | caption}}
              </button>
              <button nxButton="primary small" type="button" (click)="saveSettings()" [disabled]="saving">
                @if (saving) {
                  <nx-spinner nxSize="small" class="nx-margin-right-2xs"></nx-spinner>
                }
                {{'pdfColors.save' | caption}}
              </button>
            </div>
          </div>
        </div>
      }
    </div>
